




























































































// import AuthApi from "@/api/auth";
import { Component, Vue } from "vue-property-decorator";
import AdminApi from "@/api/admin/admin";
import Encrypt from "@/utils/encrypt";
import { AdminModel, InitRequestModel } from "@/api/types";

@Component({
  components: {},
})
export default class Login extends Vue {
  loading = false;
  initMode = false;
  verifyMode = true;
  initPassword = "";

  labelCol = { span: 24 };
  wrapperCol = { span: 24 };

  data = {
    name: "",
    password: "",
  };

  async submit() {
    try {
      this.loading = true;
      const request: InitRequestModel = {
        initPassword: Encrypt.hash(this.initPassword),
      };
      const result = await AdminApi.checkInitPassword(request);

      if (result.result) {
        this.verifyMode = false;
      } else {
        throw "";
      }
    } catch {
      this.$message.error("초기 비밀번호가 옳지 않습니다.");
    } finally {
      this.loading = false;
    }
  }

  async registSubmit() {
    try {
      this.loading = true;

      if (this.data.name == "" || this.data.password == "") {
        this.$message.error("데이터를 입력해주세요");
        return;
      }

      const data: AdminModel = {
        ...this.data,
        password: Encrypt.hash(this.data.password),
        type: 0,
      };
      const result = await AdminApi.signup(data);

      if (!result.result || !result.token || result.token == "") {
        throw "";
      }

      localStorage.setItem("token", result.token);
      location.href = "/";
    } catch {
      this.$message.error("회원가입에 실패하였습니다.");
    } finally {
      this.loading = false;
    }
  }

  async loginSubmit() {
    try {
      this.loading = true;
      const result = await AdminApi.login({
        email: this.data.name,
        // pw: Encrypt.hash(this.data.password),
        pw: this.data.password,
      });

      if (!result.token) {
        throw "";
      }

      localStorage.setItem("token", result.token);
      location.href = "/member";
    } catch {
      this.$message.error("계정정보가 옳지 않습니다.");
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    const result = await AdminApi.checkInit();
    console.log("result :>> ", result);
    if (result.result) {
      this.initMode = true;
    }
  }
}
